import { createRouter, createWebHistory } from '@ionic/vue-router'
import { RouteRecordRaw } from 'vue-router'

import Main from '@/components/main/Main.vue'
import MainContainer from '@/containers/main/Main.ts'

declare const window: any

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'NotFound',
    component: () => import('@/components/not-found/NotFound.vue'),
  },
  {
    path: '/:moderationCode',
    name: 'QuestionModeration',
    component: MainContainer(Main),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  const { fullPath } = to
  const url = `${document.location.origin}${fullPath}`

  if (window.ga) {
    window.ga('set', 'page', fullPath)
    window.ga('set', 'location', url)
    window.ga('send', 'pageview')
  }
})

export default router
